import * as APP from 'config/app';
import classNames from 'classnames';
import Icon from 'app/components/partials/icon';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const Share = ({ name, media, subject, text, url }) => {
    const [isShown, setIsShown] = useState(false);

    const togglePopover = () => {
        setIsShown((old) => !old);
    };

    return (
        <section
            className={classNames('share-block', {
                visible: isShown,
            })}
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
        >
            <div className="links" id="share-links">
                <a className="link || ssk ssk-twitter" rel="noreferrer" href={`https://twitter.com/intent/tweet/?text=${subject}&url=${APP.APP_HOSTNAME}${url}&via=${APP.TWITTER_USER.replace('@', '')}`} target="_blank">
                    <Icon name="twitter" title="Twitter" />
                </a>

                <a className="link || ssk ssk-facebook" rel="noreferrer" href={`https://facebook.com/dialog/share?app_id=${APP.FACEBOOK_APP_ID}&display=popup&href=${APP.APP_HOSTNAME}${url}`} target="_blank">
                    <Icon name="facebook-alt" title="Facebook" />
                </a>

                <a className="link || ssk ssk-pinterest" rel="noreferrer" href={`https://pinterest.com/pin/create/button/?url=${APP.APP_HOSTNAME}${url}&description=${subject}&media=${media}`} target="_blank">
                    <Icon name="pinterest" />
                </a>

                <a className="link || ssk ssk-tumbler" rel="noreferrer" href={`https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=${APP.APP_HOSTNAME}${url}&title=${subject}&caption=&content=&shareSource=${APP.TUMBLR_USER}`} target="_blank">
                    <Icon name="tumbler" />
                </a>

                <a className="link" href={`mailto:?subject=${subject}&body=${text}%0A%0A${name}%0A%0A${APP.APP_HOSTNAME}${url}`}>
                    <Icon name="email" />
                </a>
            </div>

            <button
                className="toggle"
                aria-expanded={isShown}
                aria-controls="share-links"
                onClick={togglePopover}
                // allow Esc to close the popover to satsify the dismissible success criterion
                // https://www.w3.org/WAI/WCAG22/Understanding/content-on-hover-or-focus.html
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        setIsShown(false);
                    }
                }}
            >
                <Icon name="share" />
                <span>Share</span>
            </button>
        </section>

    );
};

Share.propTypes = {
    name: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};

export default Share;
